import { Injectable } from '@angular/core';

/** Collapsed Goals columns per user + campaign. Shared Reports and anonymous sessions keep them in memory only. */
@Injectable({
  providedIn: 'root',
})
export class CampaignDetailsGoalsCollapseStateService {
  private readonly memory = new Map<string, string[]>();
  private readonly storagePrefix = 'campaign-goals-collapsed';

  public load(campaignId: string, userId: string | null, exportMode: boolean): string[] {
    const key = this.buildKey(campaignId, userId);

    if (exportMode || !userId) {
      return this.memory.get(key) ?? [];
    }

    try {
      const parsed: unknown = JSON.parse(window.localStorage.getItem(key) ?? '[]');

      return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
    } catch {
      return this.memory.get(key) ?? [];
    }
  }

  public save(campaignId: string, userId: string | null, exportMode: boolean, collapsedIds: string[]): void {
    const key = this.buildKey(campaignId, userId);

    this.memory.set(key, collapsedIds);

    if (exportMode || !userId) {
      return;
    }

    try {
      if (collapsedIds.length) {
        window.localStorage.setItem(key, JSON.stringify(collapsedIds));
      } else {
        window.localStorage.removeItem(key);
      }
    } catch {
      // Storage full or blocked: the in-memory copy above keeps the session working.
    }
  }

  private buildKey(campaignId: string, userId: string | null): string {
    return `${this.storagePrefix}:${userId ?? 'anonymous'}:${campaignId}`;
  }
}
